<template>
  <div class="text-2xs rounded-md p-0.5 px-1.5 font-medium uppercase">
    {{ $t('pdp.promotion.free_label') }}
  </div>
</template>
